import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import Products from './components/Products';
import { withRouter } from 'react-router-dom';

const HardwareProducts = () => (
    <div className="container-fluid software-products">
        <div className="row">
            <div className="col-md-12">
                <div className="heading">Informasjon</div>
                <Products/>
            </div>
        </div>
    </div>
);

export default HardwareProducts;


